import update from "immutability-helper";
import { createSlice } from "@reduxjs/toolkit";
import { fetchConfigSuccess, fetchConfigFailed } from "./index";

export const initialState = {
  data: null,
  fetchEnded: false,
};

const fetchConfigSuccessHandler = (state, action) => {
  return update(state, {
    data: { $set: action.payload },
    fetchEnded: { $set: true },
  });
};

const fetchConfigFailedHandler = (state) => {
  return update(state, {
    fetchEnded: { $set: true },
  });
};

const configurationSlice = createSlice({
  name: "configuration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfigSuccess, (state, action) => fetchConfigSuccessHandler(state, action));
    builder.addCase(fetchConfigFailed, (state) => fetchConfigFailedHandler(state));
  },
});

export const configurationReducer = configurationSlice.reducer;
